import * as yup from "yup";

const URL_REGEX = /^$|^([hH][tT][tT][pP][sS]?:\/\/)?[-a-zA-Z0-9@:%._+~#=]{1,253}\.[a-zA-Z]{1,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/;

export const validationSchema = yup.object({
    incentiveParticipation: yup.string().required("Please select an option"),
    incentiveContact: yup.array().default([]).when('incentiveParticipation', {
        is: "true",
        then: (schema) => schema.min(1, "Please select at least one option")
    }),
    referralSource: yup.string().default("").required("Please enter how you heard about GEICO"),
    agencyWebsite: yup.string().default("").matches(URL_REGEX, "Please enter a valid URL"),
    agencyFacebook: yup.string().default(""),
    agencyInstagram: yup.string().default(""),
});